import React, { useContext, useEffect, useState } from "react";
import "./RelatorioAdmin.css";
import { Col, Row, Button, Table, Tag } from "antd";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import os_icon from "../../../../assets/images/OS.png";
import money_bag from "../../../../assets/images/money_bag.png";
import hand_money from "../../../../assets/images/hand_money.png";
import card from "../../../../assets/images/card.png";
import pix_icon from "../../../../assets/images/pix.png";
import credito_icon from "../../../../assets/images/credito.png";
import debito_icon from "../../../../assets/images/debito.png";
import especie_icon from "../../../../assets/images/especie.png";
import * as links from "../../../../utils/links";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

ChartJS.register(ArcElement, Tooltip, Legend);
const RelatorioAdmin = (props) => {
  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;
  let navigate = useNavigate();
  const location = useLocation();

  const locationState = location.state || {};
  const maquinaInfos = locationState?.maquinaInfos || null;
  const dataInicio = locationState?.dataInicio || null;
  const dataFim = locationState?.dataFim || null;

  const { id } = useParams();

  const token = authInfo?.dataUser?.token;
  const hasPeriodoValido = Boolean(dataInicio && dataFim);
  const periodoInicioLabel = dataInicio ? moment(dataInicio).format("DD/MM/YYYY") : "--/--/----";
  const periodoFimLabel = dataFim ? moment(dataFim).format("DD/MM/YYYY") : "--/--/----";

  const [estornos, setEstornos] = useState({ SOMA: "0" });
  const [pagamentos, setPagamentos] = useState({
    PIX: "0",
    ESPECIE: "0",
    CREDITO: "0",
    DEBITO: "0",
  });
  const [taxas, setTaxas] = useState({
    PIX: "0",
    CREDITO: "0",
    DEBITO: "0",
  });
  const [isLoading, setIsLoading] = useState(true);
  const reportRef = React.useRef(null);
  const handleDownloadPDF = async () => {
    try {
      if (!hasPeriodoValido) return;
      const element = reportRef.current;
      if (!element) return;
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      const periodo = `${moment(dataInicio).format("YYYY-MM-DD")}_a_${moment(dataFim).format("YYYY-MM-DD")}`;
      pdf.save(`relatorio-admin-${periodo}.pdf`);
    } catch (e) {
      console.error("Erro ao gerar PDF", e);
    }
  };
  const [transacoes, setTransacoes] = useState([]);
  const [loadingTransacoes, setLoadingTransacoes] = useState(false);
  const toNumber = (v) => {
    if (typeof v === "number") return v;
    if (!v) return 0;
    const s = String(v)
      .replace(/\s/g, "")
      .replace(/R\$|\./g, "")
      .replace(/,/g, ".")
      .replace(/[^0-9.-]/g, "");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  };
  const normalizeTipoPagamento = (tipo) => {
    const value = String(tipo || "").trim().toLowerCase();

    if (!value) return null;
    if (["bank_transfer", "account_money", "conta mercado pago", "11", "pix"].includes(value)) return "PIX";
    if (["cash", "especie", "espécie"].includes(value)) return "ESPECIE";
    if (["debit_card", "8", "debito", "débito", "debit"].includes(value)) return "DEBITO";
    if (["credit_card", "prepaid_card", "1", "credito", "crédito", "credit"].includes(value)) {
      return "CREDITO";
    }
    if (["saiu premio", "premio", "prêmio"].includes(value)) return "PREMIO";
    return null;
  };
  const filtrarTransacoesPorPeriodo = (transacoesPeriodo = []) => {
    if (!Array.isArray(transacoesPeriodo) || !hasPeriodoValido) return Array.isArray(transacoesPeriodo) ? transacoesPeriodo : [];

    const dataInicial = moment(dataInicio).startOf("day");
    const dataFinal = moment(dataFim).endOf("day");

    return transacoesPeriodo.filter((transacao) => {
      if (!transacao?.data) return false;
      const dataTransacao = moment(transacao.data);
      return dataTransacao.isValid() && dataTransacao.isBetween(dataInicial, dataFinal, undefined, "[]");
    });
  };
  const getPieChartData = () => {
    const pix = toNumber(pagamentos?.PIX);
    const especie = toNumber(pagamentos?.ESPECIE);
    const credito = toNumber(pagamentos?.CREDITO);
    const debito = toNumber(pagamentos?.DEBITO);
    return {
      labels: ["PIX", "Espécie", "Crédito", "Débito"],
      datasets: [
        {
          data: [pix, especie, credito, debito],
          backgroundColor: ["#2f54eb", "#722ed1", "#52c41a", "#fa8c16"],
          borderColor: "#fff",
          borderWidth: 2,
        },
      ],
    };
  };
  const pieOptions = {
    plugins: {
      legend: { position: "bottom", labels: { color: "rgba(233, 242, 255, 0.9)" } },
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(10, 18, 35, 0.92)",
        titleColor: "rgba(233, 242, 255, 0.92)",
        bodyColor: "rgba(233, 242, 255, 0.9)",
      },
    },
    maintainAspectRatio: false,
  };

  useEffect(() => {
    if (!hasPeriodoValido) {
      setIsLoading(false);
      setNotiMessage({
        type: "error",
        message: "Selecione a data de início e fim antes de abrir o relatório de pagamentos.",
      });
      navigate(`${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/${id}`, {
        replace: true,
        state: locationState || undefined,
      });
      return;
    }

    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    return () => clearInterval(intervalId);
  }, [hasPeriodoValido, id]);

  const dataData = async () => {
    try {
      setIsLoading(true);

      if (!token || !hasPeriodoValido) {
        setIsLoading(false);
        return;
      }

      let body = { maquinaId: id };
      body.dataInicio = moment(dataInicio).startOf("day").toISOString();
      body.dataFim = moment(dataFim).endOf("day").toISOString();

      const [estornosVal, taxasVal, pagamentosVal, cashVal] = await Promise.allSettled(
        [
          axios.post(
            `${process.env.REACT_APP_SERVIDOR}/relatorio-04-estornos-adm`,
            body,
            {
              headers: {
                "x-access-token": token,
                "content-type": "application/json",
              },
            }
          ),
          axios.post(
            `${process.env.REACT_APP_SERVIDOR}/relatorio-02-taxas-adm`,
            body,
            {
              headers: {
                "x-access-token": token,
                "content-type": "application/json",
              },
            }
          ),
          axios.post(
            `${process.env.REACT_APP_SERVIDOR}/relatorio-03-pagamentos-adm`,
            body,
            {
              headers: {
                "x-access-token": token,
                "content-type": "application/json",
              },
            }
          ),
          axios.post(
            `${process.env.REACT_APP_SERVIDOR}/relatorio-01-cash-adm`,
            body,
            {
              headers: {
                "x-access-token": token,
                "content-type": "application/json",
              },
            }
          ),
        ]
      );
      const falhas = [estornosVal, taxasVal, pagamentosVal, cashVal].filter(
        (resultado) => resultado.status === "rejected"
      );

      if (falhas.some((resultado) => [401, 403].includes(resultado?.reason?.response?.status))) {
        setIsLoading(false);
        setNotiMessage({
          type: "error",
          message: "A sua sessão expirou, para continuar faça login novamente.",
        });
        return;
      }

      let transacoesPeriodo = [];
      // Transações do período (admin)
      try {
        setLoadingTransacoes(true);
        const transResp = await axios.post(
          `${process.env.REACT_APP_SERVIDOR}/pagamentos-periodo-adm/${id}`,
          { dataInicio: body.dataInicio, dataFim: body.dataFim },
          {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        );
        transacoesPeriodo = Array.isArray(transResp?.data?.pagamentos) ? transResp.data.pagamentos : [];
        setTransacoes(filtrarTransacoesPorPeriodo(transacoesPeriodo));
      } catch (e) {
        transacoesPeriodo = [];
        setTransacoes([]);
      } finally {
        setLoadingTransacoes(false);
      }
      setEstornos({
        SOMA: estornosVal.status === "fulfilled" ? estornosVal.value?.data?.valor || "0" : "0",
      });

      setTaxas({
        PIX: taxasVal.status === "fulfilled"
          ? taxasVal.value?.data?.pix || "0"
          : "0",
        CREDITO: taxasVal.status === "fulfilled"
          ? taxasVal.value?.data?.credito || "0"
          : "0",
        DEBITO: taxasVal.status === "fulfilled"
          ? taxasVal.value?.data?.debito || "0"
          : "0",
      });

      setPagamentos({
        PIX: pagamentosVal.status === "fulfilled"
          ? pagamentosVal.value?.data?.pix || "0"
          : "0",
        CREDITO: pagamentosVal.status === "fulfilled"
          ? pagamentosVal.value?.data?.credito || "0"
          : "0",
        DEBITO: pagamentosVal.status === "fulfilled"
          ? pagamentosVal.value?.data?.debito || "0"
          : "0",
        ESPECIE: cashVal.status === "fulfilled"
          ? cashVal.value?.data?.valor || "0"
          : "0",
      });

      if (falhas.length > 0) {
        console.error("Falha ao carregar parte do relatório de pagamentos (admin)", falhas);
        setNotiMessage({
          type: "warning",
          message:
            "Alguns dados do relatório não puderam ser carregados. Verifique o período selecionado ou tente novamente.",
        });
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Erro ao carregar relatório de pagamentos (admin)", error);
      setIsLoading(false);

      setNotiMessage({
        type: "error",
        message: "Não foi possível carregar o relatório de pagamentos.",
      });
    }
  };

  const columnsTransacoes = [
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (data) => <span>{moment.utc(data).format("DD/MM/YYYY HH:mm:ss")}</span>,
    },
    {
      title: "Forma de pagamento",
      dataIndex: "tipo",
      key: "tipo",
      render: (tipo) => {
        const map = {
          PIX: { color: "geekblue", text: "PIX" },
          ESPECIE: { color: "purple", text: "Espécie" },
          DEBITO: { color: "orange", text: "Débito" },
          CREDITO: { color: "green", text: "Crédito" },
          PREMIO: { color: "volcano", text: "Prêmio" },
        };
        const normalized = normalizeTipoPagamento(tipo);
        const cfg = normalized ? map[normalized] : { color: "default", text: tipo };
        return <Tag color={cfg.color}>{cfg.text}</Tag>;
      },
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (valor) =>
        new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor),
    },
    {
      title: "Identificador",
      dataIndex: "mercadoPagoId",
      key: "mercadoPagoId",
    },
    {
      title: "Status",
      dataIndex: "estornado",
      key: "status",
      render: (estornado) => (estornado ? <Tag>Estornado</Tag> : <Tag color="success">Recebido</Tag>),
    },
  ];

  const normalizeTipo = (tipo) => normalizeTipoPagamento(tipo);
  const isSaidaPremio = (t) => {
    const idStr = t?.mercadoPagoId ? String(t.mercadoPagoId).toLowerCase() : "";
    return idStr.includes("saiu premio") || normalizeTipo(t?.tipo) === "PREMIO";
  };

  return (
    <div ref={reportRef} style={{ position: "relative" }}>
      {/* Marca d'água topo centralizada visível */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 200,
          backgroundImage: "url(/logo512.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center top",
          backgroundSize: 140,
          opacity: 1,
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      {/* Logo menor canto inferior direito */}
      <div
        style={{
          position: "absolute",
          right: 10,
          bottom: 10,
          width: 120,
          height: 120,
          backgroundImage: "url(/logo512.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          opacity: 1,
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      {isLoading && <LoadingAction />}
      <div className="Cliente_WarningMsgSpan">
        <span>{dataUser.warningMsg}</span>
      </div>
      <div className="Relatorio_main">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className="Relatorio_staBlockTitle">
            <span>Relatório</span>
            <br />
            <span style={{ color: "rgba(233, 242, 255, 0.7)", fontSize: "15px" }}>
              {periodoInicioLabel} - {periodoFimLabel} -{" "}
              <br/>
            </span>
          </div>
          <div className="Relatorio_staBlockTitle">
            <span style={{marginRight: '20px'}}>
              Gerado em: {moment(new Date()).format("DD/MM/YYYY HH:mm")}  
            </span>
            <Button
              style={{marginRight: '50px'}}
              onClick={() => {
                navigate(`${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/${id}`, {
                  state: location.state,
                });
              }}
            >
              <span>VOLTAR</span>
            </Button>
            <Button type="primary" onClick={handleDownloadPDF}>
              Exportar PDF
            </Button>
          </div>
        </div>
      </div>

      <Row>
        <Col xs={24} md={22} lg={22} xl={22}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Pagamentos</div>
              <div style={{ height: 280 }}>
                <Pie data={getPieChartData()} options={pieOptions} />
              </div>
              <div style={{ marginTop: 10, fontSize: 14 }}>
                <strong>PIX:</strong> {pagamentos?.PIX} | <strong>Crédito:</strong> {pagamentos?.CREDITO} | <strong>Débito:</strong> {pagamentos?.DEBITO} | <strong>Espécie:</strong> {pagamentos?.ESPECIE}
              </div>
            </div>
            <div className="Relatorio_right_side">
              <img className="Relatorio_os_icon" src={os_icon} alt="os icon" />
              <br />
              <br />
              <br />
              <img
                className="Relatorio_money_icon"
                src={money_bag}
                alt="os icon"
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Transações do período</div>
              <Table
                columns={columnsTransacoes}
                dataSource={transacoes}
                pagination={false}
                loading={loadingTransacoes}
                rowKey={(r) => r.id || `${r.data}-${r.valor}-${r.mercadoPagoId}`}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={22} lg={22} xl={11}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Estornos</div>
              <div className="Relatorio_inner_rows">
                <Row className="Relatorio_title_row">
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    className="Relatorio_title_col"
                  >
                    <img
                      className="Relatorio_title_col_title"
                      src={pix_icon}
                      alt="TOTAL DE ESTORNOS"
                    />
                    TOTAL DE ESTORNOS
                  </Col>
                </Row>
                <Row className="Relatorio_value_row">
                  <Col span={12}>{estornos?.SOMA}</Col>
                </Row>
              </div>
            </div>
            <div className="Relatorio_right_side">
              <img className="Relatorio_os_icon" src={os_icon} alt="os icon" />
              <br />
              <br />
              <br />
              <img className="Relatorio_money_icon" src={card} alt="os icon" />
            </div>
          </div>
        </Col>
        <Col xs={24} md={22} lg={22} xl={11}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Taxas</div>
              <div className="Relatorio_inner_rows">
              <Row>
                  <Col xs={24} md={12} lg={6}>
                    <div className="Relatorio_inner_rows">
                      <div>
                        <img
                          className="Relatorio_title_col_title"
                          src={pix_icon}
                          alt="PIX"
                        />
                        PIX
                      </div>
                      <div>{taxas?.PIX}</div>
                    </div>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <div className="Relatorio_inner_rows">
                      <div>
                        <img
                          className="Relatorio_title_col_title"
                          src={credito_icon}
                          alt="CRÉDITO"
                        />
                        CRÉDITO
                      </div>
                      <div>{taxas?.CREDITO}</div>
                    </div>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <div className="Relatorio_inner_rows">
                      <div>
                        <img
                          className="Relatorio_title_col_title"
                          src={debito_icon}
                          alt="DÉBITO"
                        />
                        DÉBITO
                      </div>
                      <div>{taxas?.DEBITO}</div>
                    </div>
                  </Col>
                </Row>
                {(() => {
                  const totalTx = toNumber(taxas?.PIX) + toNumber(taxas?.CREDITO) + toNumber(taxas?.DEBITO);
                  const fmt = (n) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n);
                  return (
                    <div style={{ marginTop: 10 }}>
                      <strong>Total das taxas:</strong> {fmt(totalTx)}
                    </div>
                  );
                })()}
              </div>
            </div>
            <div className="Relatorio_right_side">
              <img className="Relatorio_os_icon" src={os_icon} alt="os icon" />
              <br />
              <br />
              <br />
              <img
                className="Relatorio_money_icon"
                src={hand_money}
                alt="os icon"
              />
            </div>
          </div>
        </Col>
      </Row>
      {/* Resumo final movido para baixo das taxas e estornos */}
      <Row>
        <Col span={24}>
          <div className="Relatorio">
            <div className="Relatorio_left_side">
              <div className="Relatorio_title">Resumo</div>
              {(() => {
                const pix = toNumber(pagamentos?.PIX);
                const credito = toNumber(pagamentos?.CREDITO);
                const debito = toNumber(pagamentos?.DEBITO);
                const especie = toNumber(pagamentos?.ESPECIE);
                const total = pix + credito + debito + especie;
                const taxasTotal = toNumber(taxas?.PIX) + toNumber(taxas?.CREDITO) + toNumber(taxas?.DEBITO);
                const totalSemTaxas = total - taxasTotal;
                const saidasPelucia = Array.isArray(transacoes)
                  ? transacoes.filter((t) => isSaidaPremio(t))
                  : [];
                const qtdSaidaPelucia = saidasPelucia.length;
                const totalSaidaPelucia = saidasPelucia.reduce((acc, t) => acc + toNumber(t?.valor), 0);
                const fmt = (n) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n);
                return (
                  <div>
                    <div style={{ marginBottom: 10, color: "rgba(233, 242, 255, 0.7)", fontWeight: 600 }}>
                      Resumo do período: {periodoInicioLabel} - {periodoFimLabel}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 10 }}>
                      <div className="card-total">
                        <span className="card-total-title">Espécie</span>
                        <span className="card-total-value">{fmt(especie)}</span>
                      </div>
                      <div className="card-total">
                        <span className="card-total-title">PIX</span>
                        <span className="card-total-value">{fmt(pix)}</span>
                      </div>
                      <div className="card-total">
                        <span className="card-total-title">Débito</span>
                        <span className="card-total-value">{fmt(debito)}</span>
                      </div>
                      <div className="card-total">
                        <span className="card-total-title">Crédito</span>
                        <span className="card-total-value">{fmt(credito)}</span>
                      </div>
                      <div className="card-total">
                        <span className="card-total-title">Total Bruto</span>
                        <span className="card-total-value" style={{ fontWeight: 700, color: "rgba(0, 210, 255, 0.95)" }}>
                          {fmt(total)}
                        </span>
                      </div>
                      <div className="card-total">
                        <span className="card-total-title">Total Estornos</span>
                        <span className="card-total-value" style={{ fontWeight: 700, color: "#ff4d4f" }}>
                          {fmt(toNumber(estornos?.SOMA))}
                        </span>
                      </div>
                      <div className="card-total">
                        <span className="card-total-title">Total sem taxas</span>
                        <span className="card-total-value" style={{ fontWeight: 700, color: "#22c55e" }}>
                          {fmt(totalSemTaxas)}
                        </span>
                      </div>
                      <div className="card-total">
                        <span className="card-total-title">Qtd. Saída Pelúcia</span>
                        <span className="card-total-value">{qtdSaidaPelucia}</span>
                      </div>
                    </div>
                    <div style={{ color: "rgba(233, 242, 255, 0.78)" }}>
                      <strong>Taxas do período:</strong> {fmt(taxasTotal)}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RelatorioAdmin;
